import axios from "axios";
import isEmpty from "lodash/isEmpty";

import { getHeaderWithToken, getAuthHeader, getHeader } from "../headers";

// ===================================
//  LOGIN
// ===================================
export const userLoginTokenLoading = userType => {
	return {
		type: "USER_LOGIN_TOKEN_LOADING",
		userType
	};
};

export const setUserLoginToken = (token, userType, maxLoginsReached) => {
	return {
		type: "USER_LOGIN_TOKEN_SET",
		userType,
		token,
		maxLoginsReached
	};
};

export const updateUserLoginMax = (maxLoginsReached, userType) => {
	return {
		type: "UPDATE_USER_MAX_LOGIN",
		userType,
		maxLoginsReached
	};
};

export const userLoginLoading = userType => {
	return {
		type: "USER_LOGIN_LOADING",
		userType
	};
};

export const userLoginError = (err, userType) => {
	return {
		type: "USER_LOGIN_ERROR",
		err,
		userType
	};
};

export const userLoginSuccess = (payload, userType) => {
	return {
		type: "USER_LOGIN_SUCCESS",
		payload,
		userType
	};
};

export function getReviewerLoginToken() {
	return (dispatch, getState) => {
		dispatch(userLoginTokenLoading("reviewer"));

		// console.log(getState().user.loginTokens);

		const token = !!getState().user.loginTokens["reviewer"]
			? getState().user.loginTokens["reviewer"]
			: "";

		const data = {
			type: "reviewer"
		};

		return axios
			.get(process.env.REACT_APP_API_URL + "reviewer/login-token", {
				headers: getHeaderWithToken(token),
				params: data
			})
			.then(response => {
				// Error explicitly set
				if (!isEmpty(response.data.errors)) {
					dispatch(userLoginError(response.data.errors, "general"));
					return Promise.resolve();
				}
				// Error status
				else if (response.data.status !== 200) {
					dispatch(userLoginError(response.data.message, "general"));
					return Promise.resolve();
				}
				// Success
				else {
					dispatch(
						setUserLoginToken(
							response.data.token,
							"reviewer",
							response.data.maxLoginsReached
						)
					);
					return Promise.resolve(response.data);
				}
			})
			.catch(err => {
				console.log("reviewerLogin error", err);
				dispatch(userLoginError(err.response.data.message, "guest"));
				return Promise.resolve();
			});
	};
}

export function reviewerLogin(email, password, recaptcha) {
	return (dispatch, getState) => {
		dispatch(userLoginLoading("reviewer"));

		const token = getState().user.loginTokens["reviewer"];

		let data = {
			email,
			password
		};

		if (recaptcha) {
			data.recaptcha = recaptcha;
		}

		return axios
			.post(process.env.REACT_APP_API_URL + "reviewer/login", data, {
				headers: getHeaderWithToken(token)
			})
			.then(response => {
				// Error explicitly set
				if (!isEmpty(response.data.errors)) {
					dispatch(userLoginError(response.data.errors, "reviewer"));
					dispatch(updateUserLoginMax(response.data.maxLoginsReached, "reviewer"));
					return Promise.reject(response.data.errors);

					// Error status
				} else if (response.data.status !== 200) {
					dispatch(userLoginError(response.data.message, "reviewer"));
					dispatch(updateUserLoginMax(response.data.maxLoginsReached, "reviewer"));
					return Promise.reject(response.data.message);

					// Success
				} else {
					dispatch(userLoginSuccess(response.data, "reviewer"));
					return Promise.resolve(response.data);
				}
			})
			.catch(err => {
				dispatch(userLoginError({ general: err }, "reviewer"));
				return Promise.reject();
			});
	};
}

export function adminLogin(username, password) {
	return dispatch => {
		dispatch(userLoginLoading("admin"));

		const data = {
			username: username,
			password: password
		};

		return axios
			.post(process.env.REACT_APP_API_URL + "user/login", data, {
				headers: getHeader()
			})
			.then(response => {
				// Error explicitly set
				if (!isEmpty(response.data.errors)) {
					dispatch(userLoginError(response.data.errors, "admin"));
					return Promise.resolve();

					// Error status
				} else if (response.data.status !== 200) {
					dispatch(userLoginError(response.data.message, "admin"));
					return Promise.resolve();

					// Success
				} else {
					dispatch(userLoginSuccess(response.data, "admin"));
					return Promise.resolve(response.data);
				}
			})
			.catch(err => {
				console.log("adminLogin error", err);
				// if (err.response.data.errors) {
				// 	dispatch(userLoginError(err.response.data.errors, "admin"));
				// } else {
				// 	dispatch(userLoginError(err.response.data.message, "admin"));
				// }
				dispatch(userLoginError(err, "admin"));
				return Promise.resolve();
			});
	};
}

export function userCheckLogin(type) {
	return (dispatch, getState) => {
		// console.log(type, getState().user[type])

		// If user is not set
		if (!getState().user[type]) {
			dispatch(userExpiryChecked(type));
			return Promise.resolve();
		}

		const token = getState().user[type].token;

		return axios
			.get(process.env.REACT_APP_API_URL + "user/expired", {
				headers: getHeaderWithToken(token)
			})
			.then(response => {
				// User expired
				if (response.data.expired) {
					dispatch(userLogout(type));
				}
				// New user token
				else {
					dispatch(userLoginSuccess(response.data, type));
				}

				// Set user checked
				dispatch(userExpiryChecked(type));
				return Promise.resolve();
			})
			.catch(err => {
				dispatch(userLogout(type));
				dispatch(userExpiryChecked(type));
			});
	};
}

// ===================================
//  LOGOUT
// ===================================
export const userLogout = userType => {
	return {
		type: "USER_LOGOUT",
		userType
	};
};

// ===================================
//  MISC
// ===================================
export const clearErrors = () => {
	return {
		type: "CLEAR_ERRORS"
	};
};

export const userExpiryChecked = userType => {
	return {
		type: "EXPIRY_CHECKED",
		userType
	};
};

export const userTokenUpdate = (userType, token) => {
	return {
		type: "USER_TOKEN_UPDATE",
		userType,
		token
	};
};

// ===================================================================================
//  PASSWORD REQUEST
// ===================================================================================
export const passwordRequestLoading = () => {
	return {
		type: "PASSWORD_REQUEST_LOADING"
	};
};

export const passwordRequestError = err => {
	return {
		type: "PASSWORD_REQUEST_ERROR",
		err
	};
};

export const passwordRequestSuccess = payload => {
	return {
		type: "PASSWORD_REQUEST_SUCCESS",
		payload
	};
};

export function passwordRequest(email) {
	return dispatch => {
		dispatch(passwordRequestLoading());

		dispatch(getNonce("reviewer/request-password"))
			.then(nonce => {
				const params = {
					email: email
				};

				return axios
					.post(process.env.REACT_APP_API_URL + "reviewer/request-password", params, {
						headers: getHeaderWithToken(nonce)
					})
					.then(response => {
						// console.log(response)
						if (response.data.status !== 200) {
							dispatch(passwordRequestError(response.data.errors));
							return;
						}

						dispatch(passwordRequestSuccess(response));
					});
			})
			.catch(err => {
				dispatch(passwordRequestError({ general: err }));
			});
	};
}

export function getNonce(endpoint) {
	return () => {
		const params = {
			endpoint: endpoint
		};

		return axios
			.get(process.env.REACT_APP_API_URL + "nonce", {
				headers: getHeader(),
				params: params
			})
			.then(response => {
				if (response.data.status !== 200) {
					return Promise.reject(response.data.message);
				}

				return Promise.resolve(response.data.nonce);
			});
	};
}

// ===================================================================================
//  CHANGE PASSWORD
// ===================================================================================
export const changePasswordLoading = () => {
	return {
		type: "CHANGE_PASSWORD_LOADING"
	};
};

export const changePasswordError = err => {
	return {
		type: "CHANGE_PASSWORD_ERROR",
		err
	};
};

export const changePasswordSuccess = payload => {
	return {
		type: "CHANGE_PASSWORD_SUCCESS",
		payload
	};
};

export function changePassword(password_current, password_new, password_new_confirm) {
	return (dispatch, getState) => {
		dispatch(changePasswordLoading());

		dispatch(getNonce("reviewer/change-password"))
			.then(nonce => {
				const params = {
					password_current,
					password_new,
					password_new_confirm,
					email: getState().user.reviewer.user.email
				};

				return axios
					.post(process.env.REACT_APP_API_URL + "reviewer/change-password", params, {
						headers: getHeaderWithToken(nonce)
					})
					.then(response => {
						// console.log(response)
						if (response.data.status !== 200) {
							dispatch(changePasswordError(response.data.errors));
							return;
						}

						dispatch(changePasswordSuccess(response));
					});
			})
			.catch(err => {
				dispatch(changePasswordError({ general: err }));
			});
	};
}

// ===================================================================================
//  CREATE ACCOUNT
// ===================================================================================
export const createAccountLoading = () => {
	return {
		type: "CREATE_ACCOUNT_LOADING"
	};
};

export const createAccountError = err => {
	return {
		type: "CREATE_ACCOUNT_ERROR",
		err
	};
};

export const createAccountSuccess = payload => {
	return {
		type: "CREATE_ACCOUNT_SUCCESS",
		payload
	};
};

export const updateAccountSuccess = reviewer => {
	return {
		type: "UPDATE_REVIEWER_ACCOUNT_SUCCESS",
		reviewer
	};
};

export const resetUpdateAccountSuccess = reviewer => {
	return {
		type: "RESET_UPDATE_ACCOUNT_SUCCESS"
	};
};

export function registerAccount(reviewer) {
	return (dispatch, getState) => {
		dispatch(createAccountLoading());

		// Determine if updating or creating
		const endpoint = "register";

		// Pass in reviewer token if updating (since they must be logged in)
		const token = reviewer.id ? getState().user.reviewer.token : null;

		return axios
			.post(process.env.REACT_APP_API_URL + "reviewer/" + endpoint, reviewer, {
				headers: getHeaderWithToken(token)
			})
			.then(response => {
				if (!isEmpty(response.data.errors)) {
					dispatch(createAccountError(response.data.errors));
					return;

					// Error status
				} else if (!!response.data.status && response.data.status !== 200) {
					// Log user out if token expired, token, etc
					if (response.data.status === 403) {
						dispatch(userLogout("reviewer"));
					}

					dispatch(createAccountError({ general: response.data.message }));

					// SUCCESS
				} else {
					if (reviewer.id) {
						dispatch(updateAccountSuccess(response.data.formatted_values));
					} else {
						dispatch(createAccountSuccess(response.data));
					}
				}
			})
			.catch(err => {
				dispatch(createAccountError({ general: err }));
			});
	};
}

export function createAccount(reviewer) {
	return (dispatch, getState) => {
		dispatch(createAccountLoading());

		// Determine if updating or creating
		const endpoint = reviewer.id ? "update" : "create";

		// Pass in reviewer token if updating (since they must be logged in)
		const token = reviewer.id ? getState().user.reviewer.token : null;

		return axios
			.post(process.env.REACT_APP_API_URL + "reviewer/" + endpoint, reviewer, {
				headers: getHeaderWithToken(token)
			})
			.then(response => {
				if (!isEmpty(response.data.errors)) {
					dispatch(createAccountError(response.data.errors));
					return;

					// Error status
				} else if (!!response.data.status && response.data.status !== 200) {
					// Log user out if token expired, token, etc
					if (response.data.status === 403) {
						dispatch(userLogout("reviewer"));
					}

					dispatch(createAccountError({ general: response.data.message }));

					// SUCCESS
				} else {
					if (reviewer.id) {
						dispatch(updateAccountSuccess(response.data.formatted_values));
					} else {
						dispatch(createAccountSuccess(response.data));
					}
				}
			})
			.catch(err => {
				dispatch(createAccountError({ general: err }));
			});
	};
}

// ===================================================================================
//  CHANGE PASSWORD
// ===================================================================================
export const passwordUpdateLoading = () => {
	return {
		type: "PASSWORD_UPDATE_LOADING"
	};
};

export const passwordUpdateError = err => {
	return {
		type: "PASSWORD_UPDATE_ERROR",
		err
	};
};

export const passwordUpdateSuccess = payload => {
	return {
		type: "PASSWORD_UPDATE_SUCCESS",
		payload
	};
};

export const passwordUpdateClearErrors = () => {
	return {
		type: "PASSWORD_UPDATE_CLEAR_ERRORS"
	};
};

export const resetChangePasswordSuccess = () => {
	return {
		type: "RESET_CHANGE_PASSWORD_SUCCESS"
	};
};

export function updateReviewerPassword(data) {
	return (dispatch, getState) => {
		dispatch(passwordUpdateLoading());

		return axios
			.post(process.env.REACT_APP_API_URL + "reviewer/update-password", data, {
				headers: getAuthHeader(getState().user)
			})
			.then(response => {
				// console.log(response)
				if (response.data.status !== 200) {
					dispatch(passwordUpdateError(response.data.errors));
					return;
				}

				dispatch(passwordUpdateSuccess(response));
			})
			.catch(err => {
				dispatch(passwordUpdateError({ general: err }));
			});
	};
}

// ===================================================================================
//	REGISTRATIONS
// ===================================================================================
export const registrationsSet = data => {
	return {
		type: "REGISTRATIONS_SET",
		data
	};
};

// ===================================================================================
//  GET REVIEWER REVIEWS
// ===================================================================================
export const reviewerReviewsLoading = () => {
	return {
		type: "UPDATE_REVIEWER_REVIEWS_LOADING"
	};
};

export const reviewerReviewsError = err => {
	return {
		type: "UPDATE_REVIEWER_REVIEWS_ERROR",
		err
	};
};

export const reviewerReviewsSuccess = data => {
	return {
		type: "UPDATE_REVIEWER_REVIEWS_SUCCESS",
		data
	};
};

export function getReviewerReviews() {
	return (dispatch, getState) => {
		dispatch(reviewerReviewsLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + "reviewer/reviews", {
				headers: getAuthHeader(getState().user)
			})
			.then(response => {
				if (response.data.status !== 200) {
					dispatch(reviewerReviewsError(response.data.errors));
					return;
				}

				dispatch(reviewerReviewsSuccess(response));
			})
			.catch(err => {
				dispatch(reviewerReviewsError({ general: err }));
			});
	};
}

// ===================================================================================
//  GET REVIEWER TRAINING EDUCATION SIGNUPS
// ===================================================================================
export const reviewerTrainingEducationLoading = () => {
	return {
		type: "UPDATE_REVIEWER_TRAINING_EDUCATION_LOADING"
	};
};

export const reviewerTrainingEducationError = err => {
	return {
		type: "UPDATE_REVIEWER_TRAINING_EDUCATION_ERROR",
		err
	};
};

export const reviewerTrainingEducationSuccess = data => {
	return {
		type: "UPDATE_REVIEWER_TRAINING_EDUCATION_SUCCESS",
		data
	};
};

export function getReviewerTrainingEducationSignups() {
	return (dispatch, getState) => {
		dispatch(reviewerTrainingEducationLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + "reviewer/training-education", {
				headers: getAuthHeader(getState().user)
			})
			.then(response => {
				if (response.data.status !== 200) {
					dispatch(reviewerTrainingEducationError(response.data.errors));
					return;
				}

				dispatch(reviewerTrainingEducationSuccess(response));
			})
			.catch(err => {
				dispatch(reviewerTrainingEducationError({ general: err }));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/user.js